import { createContext, useState } from "react";

export const ProspectContext = createContext();

const ProspectProvider = ({ children }) => {
  const propectInLocal = localStorage.getItem("contact")
    ? JSON.parse(localStorage.getItem("contact"))
    : undefined;

  const [prospectInfo, setProspectInfo] = useState(propectInLocal);

  const setProspectInfoLocal = (data) => {
    setProspectInfo(data);
    localStorage.setItem("contact", JSON.stringify(data));
  };

  /* Limpia el prospecto — usado por el botón "Salir" del navbar cuando
     el visitante quiere volver a estado anónimo. No toca iboInfo (esa
     información sirve para el tracking del referente, se limpia con el
     logOut real del AuthContext). */
  const clearProspectInfo = () => {
    setProspectInfo(undefined);
    localStorage.removeItem("contact");
  };

  return (
    <ProspectContext.Provider
      value={{
        prospectInfo,
        setProspectInfoLocal,
        clearProspectInfo,
      }}
    >
      {children}
    </ProspectContext.Provider>
  );
};

export default ProspectProvider;
